import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AlertBreeze, Body, Caption, Heading, IconCompanies, IconContacts, LayoutGrid, LayoutHorizontal, LayoutSpaceVertical, Toggle, TooltipInfo } from 'breeze-intelligence-kit';
import { useSettingsBanner } from './useSettingsBanner';
import { useEnrichableObjectTypes } from '../EnrichableObjectTypesProvider';
import { CompanyLabel, ContactLabel } from '../EnrichableObjectTypesProvider/EnrichmentLabels';
import { usageTracker } from '../../usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrichmentToggleLabel = ({
  children
}) => /*#__PURE__*/_jsx(Caption, {
  as: "div",
  children: /*#__PURE__*/_jsx(LayoutHorizontal, {
    gap: "space-xxs",
    children: children
  })
});
const EnrichmentToggle = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
    gap: "space-sm",
    children: [children, /*#__PURE__*/_jsx(Toggle, Object.assign({}, rest))]
  });
};
export const EnrichmentSettingsNudge = () => {
  const {
    companyEnrichmentAuto,
    contactEnrichmentAuto,
    isContactEnrichment,
    isAutoEnrichmentNudgeOpen,
    onCloseBanner,
    onToggleCompanyEnrichmentAuto,
    onToggleContactEnrichmentAuto
  } = useSettingsBanner();
  const {
    companyLabelPluralLowercase,
    contactLabelPluralLowercase
  } = useEnrichableObjectTypes();
  if (!isAutoEnrichmentNudgeOpen) {
    return null;
  }
  usageTracker.track('interaction', {
    screen: 'enrichment-properties-panel',
    subscreen: isContactEnrichment ? 'contact' : 'company',
    action: 'opened-auto-enrichment-nudge'
  });
  return /*#__PURE__*/_jsx(AlertBreeze, {
    closeable: true,
    onClose: onCloseBanner,
    role: "alert",
    children: /*#__PURE__*/_jsxs(LayoutGrid, {
      alignItems: "center",
      gap: "space-lg",
      gridTemplateColumns: "1fr auto auto",
      paddingBlock: "space-sm",
      paddingInlineEnd: "space",
      children: [/*#__PURE__*/_jsxs(LayoutSpaceVertical, {
        gap: "space-xxs",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h6",
          children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
            gap: "space-xxs",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "enrichmentProperties.settings.autoEnrichment.title"
            }), /*#__PURE__*/_jsx(TooltipInfo, {
              tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "enrichmentProperties.settings.autoEnrichment.tooltip"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Body, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.settings.autoEnrichment.description"
          })
        })]
      }), /*#__PURE__*/_jsx(EnrichmentToggle, {
        "aria-label": I18n.text('enrichmentProperties.settings.autoEnrichment.toggle', {
          objectType: companyLabelPluralLowercase
        }),
        checked: companyEnrichmentAuto,
        onChange: onToggleCompanyEnrichmentAuto,
        children: /*#__PURE__*/_jsxs(EnrichmentToggleLabel, {
          children: [/*#__PURE__*/_jsx(IconCompanies, {
            size: "xxs",
            variant: "light"
          }), /*#__PURE__*/_jsx(CompanyLabel, {})]
        })
      }), /*#__PURE__*/_jsx(EnrichmentToggle, {
        "aria-label": I18n.text('enrichmentProperties.settings.autoEnrichment.toggle', {
          objectType: contactLabelPluralLowercase
        }),
        checked: contactEnrichmentAuto,
        onChange: onToggleContactEnrichmentAuto,
        children: /*#__PURE__*/_jsxs(EnrichmentToggleLabel, {
          children: [/*#__PURE__*/_jsx(IconContacts, {
            size: "xxs",
            variant: "light"
          }), /*#__PURE__*/_jsx(ContactLabel, {})]
        })
      })]
    })
  });
};